/**
 * 路由钩子动画
 * @param route
 * @param store
 * @returns {*}
 */
export default function(route, store) {

  window.popGesture = () => {
    store.commit('pageTranSet', { popGesture: true })
  }

  route.beforeEach((to, from, next) => {
    if (!from || !from.path || !from.meta.level) {
      store.commit('pageTranSet', {
        transitionType: 'fade',
        transitionMode: 'out-in',
      });
    } else {
      let transitionMode = null;
      let transitionType = '';
      const _from = from.meta.level;
      const _to = to.meta.level;

      if (_from < _to) {
        transitionType = 'slidel';
      } else if (_from > _to) {
        transitionType = 'slider';
      } else {
        transitionType = 'fade';
        transitionMode = 'out-in';
      }
      if(store.state.pageTranSet.popGesture) {
        setTimeout(() => {
          store.commit('pageTranSet', {popGesture: false })
        }, 10);
      } else {
        store.commit('pageTranSet', {transitionType, transitionMode});
      }
    }
    next();
  });

  route.afterEach((route) => {
    if (route.meta && route.meta.title) {
      store.commit('pageTitle', {pageTitle: route.meta.title});
    }
  });
  return route;
}
